// TEAMS Website - MissionAboutSection Component
// Mission statement and team preview with stats

import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useScrollReveal, useScrollRevealStagger } from '../../hooks/useScrollReveal.js';
import Button from '../ui/Button.jsx';
import { missionStats, missionValues } from '../../data/team.js';
import { ANIMATION_TIMING } from '../../styles/animation.js';
import '../../styles/main.scss';
import SectionHeader from '../ui/SectionHeader.jsx';

const MissionAboutSection = () => {
  const { t } = useTranslation();
  
  // Get team data
  const [ref, isVisible] = useScrollReveal({ threshold: 0.1 });
  const [teamRef, teamElements] = useScrollRevealStagger(missionValues.length, { staggerDelay: ANIMATION_TIMING.STAGGER_DELAY });

  return (
    <section className="mission-section" ref={ref}>
      <div className="mission-section__container">
        <div className={`mission-section__content ${isVisible ? 'mission-section__content--visible' : ''}`}>
          {/* Header */}
          <SectionHeader
            title={t('mission.title')}
            subtitle={t('mission.description')}
            alignment="center"
            size="large"
          />

          {/* Values Grid */}
          <div className="mission-section__values" ref={teamRef}>
            {missionValues.map((value, index) => (
              <div
                key={value.key}
                ref={teamElements[index]?.ref}
                className={`card mission-section__value-card ${
                  teamElements[index]?.isVisible ? 'mission-section__value-card--visible' : ''
                }`}
              >
                <div className="mission-section__value-icon">
                  <img src={value.icon} alt={t(value.title)} className="mission-section__value-icon-img" />
                </div>
                <h2 className="mission-section__value-title">
                  {t(value.title)}
                </h2>
                <p className="mission-section__value-description">
                  {t(value.description)}
                </p>
              </div>
            ))}
          </div>

          {/* Stats Bar 
          <div className="mission-section__stats">
            {missionStats.map((stat, index) => (
              <div key={index} className="mission-section__stat">
                <div className="mission-section__stat-number">
                  {stat.number}
                </div>
                <div className="mission-section__stat-label">
                  {t(stat.label)}
                </div>
              </div>
            ))}
          </div>
          */}
          {/* Call to Action */}
          <div className="mission-section__cta">
            <Link to="/association">
              <Button variant="secondary" size="large">
                {t('mission.readMore')}
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MissionAboutSection;
